// extracted by mini-css-extract-plugin
export default {"container":"NumericalInput_container__IOXVu","disabled":"NumericalInput_disabled__xCZ12","input":"NumericalInput_input__dbMUR","span":"NumericalInput_span__Hb1sF"};